export const environment = {
  production: true,
  disableSentry: false,
}
